<div class="payment-link-dialog">
  <h3>Onboarding link</h3>
  <form [formGroup]="paymentLinkForm">
    <div class="payment-link-form">
      <div>
        <mat-form-field *ngIf="showAccountType()" floatLabel="always" appearance="outline" class="full-width">
          <mat-label>Account Type</mat-label>
          <mat-select placeholder="Select an account type to enable link generation" formControlName="account_type">
            <mat-option *ngFor="let item of accountTypeOptions" [value]="item.id">{{item.name}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="o-flex o-flex--gap-1">
        <div class="feature-field  o-flex--full">
          <mat-form-field class="full-width" appearance="outline" floatLabel="always">
            <mat-label>Link expires on</mat-label>
            <input matInput [matDatepicker]="picker2" (click)="picker2.open()"
              formControlName="link_expiration_date" />
            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
            <mat-datepicker #picker2></mat-datepicker>
            <mat-hint>This is also the discount expiry date</mat-hint>
          </mat-form-field>
        </div>

        <div class="feature-field o-flex--full">
          <mat-form-field class="full-width" appearance="outline" floatLabel="always">
            <mat-label>Plan start date</mat-label>
            <input matInput [matDatepicker]="picker3" (click)="picker3.open()" formControlName="plan_start_date" />
            <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
            <mat-datepicker #picker3></mat-datepicker>
            <mat-hint>Only for post-dated plans that should start sometime after they are purchased. Otherwise leave empty</mat-hint>
          </mat-form-field>
        </div>
      </div>

      <!-- Discount --->
      <details class="payment-link__discount-details">
        <summary>Add discount</summary>
        <div>
          <div class="payment-link-generate__feature-field">
            <mat-form-field class="full-width" appearance="outline" floatLabel="always">
              <mat-label> Discount</mat-label>
              <input matInput id="discount" name="discount" formControlName="discount_value" />
            </mat-form-field>
            <mat-form-field style="width: 20%" appearance="outline" floatLabel="always">
              <mat-select formControlName="discount_type" placeholder="Select a type">
                <mat-option *ngFor="let discType of discountTypes" [value]="discType.id">
                  {{ discType.name }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <!-- Discount End --->
          <!-- Apply For --->
          <div class="payment-link-generate__feature-field">
            <mat-form-field class="full-width" appearance="outline" floatLabel="always">
              <mat-label>Apply for</mat-label>
              <input matInput formControlName="apply_for_days" />
            </mat-form-field>
            <p style="width: 20%;">days after purchased</p>
          </div>
          <!-- Apply For End --->
          
        </div>
      </details>
      <div class="payment-link-generate">
        <button *ngIf="!onboardingLink" [disabled]="!canGenerateLink()" id="generateOnboardingLink" mat-raised-button
          color="primary" (click)="generateOnboardingLink()">
          Onboarding Link
        </button>
        <code *ngIf="onboardingLink">{{onboardingLink}}</code>
        <code *ngIf="!onboardingLink">&nbsp;Add any discount prior to generating the link</code>
      </div>

      <mat-divider></mat-divider>

      <!-- 
      TODO: New email sending function in the backend required
      <div class="payment-link__email-address">
        <mat-form-field floatLabel="always" appearance="outline" class="full-width">
          <mat-label>Email address</mat-label>
          <input formControlName="email" matInput placeholder="Send the above link to this email automatically" />
        </mat-form-field>
      </div>
      -->
    </div>
  </form>
  <mat-dialog-actions align="end">
    <div>
      <button id="cancelButton" mat-button (click)="cancel()" type="button">
        Cancel
      </button>
      <button [disabled]="!paymentLinkForm.valid" id="cloneButton" mat-raised-button color="primary"
        (click)="sendEmail()">
        Send email
      </button>
    </div>
  </mat-dialog-actions>
</div>